import { Head } from "@inertiajs/react"
import { Check, Link2Off, Mail } from "lucide-react"

import { AuthHeading, HeroIcon } from "@/components/tuw/auth/AuthHeading"
import AuthLayout from "@/components/tuw/auth/AuthLayout"
import { Button } from "@/components/ui/button"

const BUTTON_CLASS = "h-auto w-full rounded-[11px] px-4 py-3 text-[14px] font-semibold"
const QUIET_CLASS = `${BUTTON_CLASS} text-muted-foreground hover:text-foreground`

// Approved customer copy. Do not edit it here.
const WORDS = {
  before: {
    title: "Stop reminders and offers",
    body: "Turn off reminder and offer emails while still getting emails about your projects.",
    action: "Stop these emails",
  },
  after: {
    title: "Reminders and offers are off",
    body: "You’ll no longer get reminder and offer emails, and you’ll still get emails about your projects.",
    action: "Turn them back on",
  },
  backOn: {
    title: "Reminders and offers are back on",
    body: "You’ll get reminder and offer emails again, along with emails about your projects.",
  },
  notWorking: {
    title: "This link no longer works",
    body: "Sign in to change your reminder and offer emails in your email settings.",
    action: "Go to email settings",
  },
}

const ICONS = { before: Mail, after: Check, backOn: Check, notWorking: Link2Off }

// The page behind the unsubscribe link in a reminder or offer email, for a
// visitor who is not signed in. `state` is where the server left the switch:
// `before` (still on), `after` (off), `backOn`, or `notWorking` for a link the
// server could not read. The two actions post as ordinary browser forms, like
// the other auth screens; the signed token in each action URL is the
// credential, so no CSRF field travels with them. Nothing here names the
// customer.
export default function RemindersAndOffers({ state, actions, links }) {
  const words = WORDS[state]

  return (
    <AuthLayout panel="signin">
      <Head title={`${words.title} · The Urban Writers`} />

      <HeroIcon icon={ICONS[state]} ok={state === "after" || state === "backOn"} />
      <AuthHeading title={words.title}>{words.body}</AuthHeading>

      {state === "before" && (
        <form method="post" action={actions.off}>
          <Button type="submit" className={BUTTON_CLASS}>
            {words.action}
          </Button>
        </form>
      )}

      {state === "after" && (
        <form method="post" action={actions.on}>
          <Button type="submit" variant="ghost" className={QUIET_CLASS}>
            {words.action}
          </Button>
        </form>
      )}

      {state === "notWorking" && (
        <Button asChild className={BUTTON_CLASS}>
          <a href={links.settings}>{words.action}</a>
        </Button>
      )}
    </AuthLayout>
  )
}
